import { truncateDecimals, parsePrice, parseWithUnit, formatTime, timeAgo } from "../utils";

export default {
  methods: {
    parsePrice(val) {
      return parsePrice(val)
    },
    parseWithUnit(val, type) {
      return parseWithUnit(val, type)
    },
    getPriceScale(val) {
      let priceScale;
      if (val >= 10) {
        priceScale = 100;
      } else if (val < 10 && val >= 1) {
        priceScale = 1000;
      } else if (val < 1 && val >= 0.0001) {
        priceScale = 100;
        while (val < 1) {
          val *= 10;
          priceScale *= 10;
        }
      } else if (val < 0.0001 && val > 0) {
        priceScale = 1000;
        while (val < 1) {
          val *= 10;
          priceScale *= 10;
        }
      } else {
        priceScale = 1000;
      }
      return priceScale;
    },
    formatTime(timeStr, now = Date.now()) {
      return formatTime(timeStr, now);
    },
    timeAgo(timeStr, now = Date.now()) {
      return timeAgo(timeStr, now);
    },
    omit(str, start, end) {
      if (str) {
        if (str.length <= start + end) {
          return str;
        }
        return `${str.substring(0, start)}...${str.substring(str.length - end)}`;
      }
    },
    changeURLArg(obj) {
      const query = location.search.substr(1);
      let queryObj = {};
      if (query) {
        _.forEach(query.split('&'), (item) => {
          let tempArr = item.split('=');
          queryObj[tempArr[0]] = tempArr[1];
        });
      }
      queryObj = { ...queryObj, ...obj };

      const newQuery = Object.keys(queryObj)
        .filter((key) => queryObj[key])
        .map((key) => `${key}=${queryObj[key]}`)
        .join('&');

      // history.replaceState('', '', `${location.pathname}?${newQuery}#/`);
      let hash = location.hash;
      let index = hash.indexOf('?');
      if (index !== -1) {
        hash = hash.substring(0, index);
      }
      // if (newQuery) {
      //   history.replaceState('', '', `${location.pathname}?${newQuery}${hash}`);
      // } else {
      //   history.replaceState('', '', `${location.pathname}${hash}`);
      // }
    },
  },
};
